import axios from '../shared/axios';
import * as events from './events';
import store from "../store/store";
import * as contractDuck from "../store/ducks/contract.duck";

export function saveEarlyWarning(data) {
    return new Promise((resolve, reject) => {
        axios.post(`/api/EarlyWarning/SaveEarlyWarning`, data)
            .then(result => {
                switch (data.actioncode) {
                    case 'CREATE':
                        events.onNotification_CREATED();
                        break;
                    case 'SAVE_DRAFT':
                        events.onNotification_DRAFT_SAVED();
                        break;
                    case 'COMMUNICATE':
                        events.onNotification_COMMUNICATED();
                        break;
                    case 'REPLY_DRAFT':
                        events.onNotification_REPLY_DRAFT_SAVED();
                        break;
                    case 'REPLY_SEND':
                        events.onNotification_REPLY_SENT();
                        break;
                    default:
                        alert('Unknown action code!');
                        break;
                }
                resolve(result);
            })
            .catch(error => reject(error));
    });
}

export function deleteEarlyWarningDraft(warningid) {
    return new Promise((resolve, reject) => {
        axios.post(`api/EarlyWarning/DeleteDraft?warningid=${warningid}`)
            .then(result => {
                events.onNotification_DELETED();
                resolve(result);
            })
            .catch(error => reject(error));
    })
}
export function getEarlyWarning(earlywarningid) {
    return axios.get(`/api/EarlyWarning/GetEarlyWarning?earlywarningid=${earlywarningid}`);
}
// export function getContractEarlyWarnings(companyid, projectid, contractid, accessibleWfIds) {
//     return axios.post(`/api/EarlyWarning/LoadEarlyWarningsList`, { accessibleWfIds }, { params: { companyid, projectid, contractid } });
// }
export function getEarlyWarningsReduced(companyid, projectid, contractid, type, accessibleWfIds) {
    return axios.post(`/api/EarlyWarning/RegisterList`, { accessibleWfIds }, { params: { companyid, projectid, contractid, party: type } });
}
export function getEarlyWarningsToSelectList(companyid, projectid, contractid) {
    return axios.get(`/api/EarlyWarning/ToSelectList`, { params: { companyid, projectid, contractid } });
}

export function ResolveRiskUpdate(data) {
    return new Promise((resolve, reject) => {
        axios.post(`/api/EarlyWarning/ResolveRiskUpdate`, data)
            .then(result => {
                store.dispatch({ type: contractDuck.actionTypes.CONTRACT_REFRESH_DASHBOARD });
                resolve(result);
            })
            .catch(error => reject(error));
    });
}

export function UpdateRisk(data) {
    return new Promise((resolve, reject) => {
        axios.post(`/api/EarlyWarning/UpdateRisk`, data)
            .then(result => {
                store.dispatch({ type: contractDuck.actionTypes.CONTRACT_REFRESH_DASHBOARD });
                resolve(result);
            })
            .catch(error => reject(error));
    });
}

export function importEarlyWarnings(data) {
    return new Promise(async (resolve, reject) => {
        try {
            const result = await axios.post(`/api/EarlyWarning/Import`, data);
            events.onNotification_CREATED();
            resolve(result);
        }
        catch (err) {
            reject(err)
        }
    });
}

export function deleteEarlyWarningDrafts(data) {
    return new Promise(async (resolve, reject) => {
        try {
            const result = await axios.delete(`/api/EarlyWarning/BulkDeleteDraft`, { data: data });
            events.onNotification_DELETED();
            resolve(result);
        }
        catch (err) {
            reject(err)
        }
    });
}

export function communicateEarlyWarningDrafts(data) {
    return new Promise(async (resolve, reject) => {
        try {
            const result = await axios.put(`/api/EarlyWarning/BulkCommunicate`, data);
            events.onNotification_COMMUNICATED();
            resolve(result);
        }
        catch (err) {
            reject(err)
        }
    });
}